import { lazy } from 'react';

// project imports
import Loadable from 'ui-component/Loadable';
import PublicBoardHeader from '../ui-component/header/PublicHeader';
const PublicProductionBoard = Loadable(lazy(() => import('views/pages/boards/PublicProductionBoard')));

// login option 3 routing

// ==============================|| AUTHENTICATION ROUTING ||============================== //

const PublicBoardRoutes = {
    path: 'public',
    element: <PublicBoardHeader />,
    children: [
        {
            path: 'production-board',
            element: <PublicProductionBoard />
        }
    ]
};

export default PublicBoardRoutes;
